<div style="overflow-y: auto" mdbModal #fiaPinsModal="mdbModal" class="modal fade right" tabindex="-1" role="dialog"
  aria-labelledby="myBasicModalLabel" aria-hidden="true" (close)="onClosed($event)">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">        
        <div class="col">
          <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
              {{ errorMessage }}
          </div>
        </div>
        <h4 class="modal-title w-50" id="myModalLabel" style="text-align: left">My FIA Pins</h4>
        <h4 class="modal-title w-50" style="text-align: right">Total Available: R {{totalAmountAvailable | number}}</h4>
      </div>
      <div class="modal-body">        
        <div *ngIf="!busy">
          <div class="table-responsive">
            <table mdbTable *ngIf="!busy && userFiaPins?.length > 0" hover="true" small="true" id="FiaPinsTable">
              <thead>
                <tr>
                  <th scope="col"> Pin</th>
                  <th scope="col"> Issue Date</th>
                  <th scope="col"> Expiry Date</th>
                  <th scope="col"> Pin Amount</th>
                  <th scope="col"> Pin Balance</th>
                  <th scope="col"> Reserved Amount</th>
                  <th scope="col"> Comment</th>
                  <th scope="col"> </th>
                </tr>
              </thead>
              <tbody>
                <tr mdbTableCol *ngFor="let pin of userFiaPins" [ngClass]="{'expired' : pin.pinIsExpired}">
                  <td class="align-middle"> {{pin.pin}} <span class="badge badge-dark" *ngIf="pin.pinIsExpired">Expired</span></td>
                  <td class="align-middle"> {{pin.pinIssueDate | date}}</td>
                  <td class="align-middle"> {{pin.pinExpiryDate | date}}</td>
                  <td class="align-middle">R {{pin.pinAmount | number}}</td>
                  <td class="align-middle">R {{pin.pinBalance | number}}</td>
                  <td class="align-middle" *ngIf="!pin.edit">R {{pin.reservedAmount | number}}</td>
                  <td class="align-middle" *ngIf="pin.edit">
                    <div class="md-form form-sm">
                      <input mdbInput type="number" id="reservedAmount" class="form-control form-control-sm">
                      <label for="reservedAmount" class="">Reserved Amount</label>
                    </div>
                  </td>
                  <td class="align-middle" *ngIf="!pin.comment && !pin.edit">-</td>
                  <td class="align-middle" *ngIf="pin.comment && !pin.edit">{{pin.comment}}</td>
                  <td class="align-middle" *ngIf="pin.edit">
                    <div class="md-form form-sm">
                      <input mdbInput type="text" id="comment" class="form-control form-control-sm">
                      <label for="comment" class="">Comment</label>
                    </div>
                  </td>
                  <td class="align-middle">
                    <button *ngIf="!pin.edit && canEdit(pin)" type="button" size="sm" mdbBtn color="trakly" class="relative waves-light"
                      (click)="editPinClicked(pin)">
                      Edit
                    </button>
                    <button *ngIf="pin.edit" type="button" size="sm" mdbBtn color="dooya-action" class="relative waves-light"
                      (click)="SavePin()">
                      Save
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col">
            <div *ngIf="!busy && userFiaPins?.length == 0" class="alert alert-info text-center font-weight-bold"
              role="alert">
              No Fia Pins available
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-right">
        <button type="button" mdbBtn color="trakly" class="relative waves-light" (click)="showHideMe(false)">Close</button>
      </div>
    </div>
</div>